<template>

  <div  style="background-color: white" v-if="merchandises" >
    <header class="bar bar-nav">
      <button class="button button-link button-nav pull-left">
        <span class="icon icon-left goback" @click="gotolast()" style="font-size: .8rem" v-if="!isWapp">返回</span>
        <span class="goback" style="margin-left: 4rem" v-if="!isWapp">
           产品详情
        </span>
        <span class="goback" style="margin-left: 7rem" v-else>
           产品详情
        </span>
      </button>
    </header>
    <div  class="content"   style="background-color: white;overflow-y: auto;overflow-x: hidden">
      <div class="page-detail"  >
        <div v-if="merchandises.specialAnnouncement" style="margin-left: 1rem;font-size: .6rem;color: red" >
          注：{{merchandises.specialAnnouncement}}
        </div>
        <div class="item-subtitle" style="color: #0894ec;margin-left: 1rem"  >
          <div class="item-title-row"  v-if="merchandises.showpromotion && merchandises.showpromotion.length > 0" >
              <div style="color: slateblue;font-size: 0.6rem;margin-left: 0.2rem" v-if="merchandises.showpromotion[0].name !== ''">参与促销：
              <div v-for="(proo,index) in merchandises.showpromotion">
                <span v-if="proo.type === 1 && proo.description !== ''">
                 {{index+1}}: {{proo.description}}
                </span>
                <span v-else-if="proo.type === 6 && proo.description !== ''">
                 {{index+1}}: {{proo.description}}
                </span>
              </div>
              </div>
          </div>
          <div v-else>
            <div class="item-title-row"  v-if="merchandises.bpromotions && merchandises.bpromotions.length > 0" >
              <div style="color: slateblue;font-size: 0.6rem;margin-left: 0.2rem" v-if="merchandises.bpromotions[0].name !== ''">参与促销：
              <div v-for="(proo,index) in merchandises.bpromotions">
                <span v-if="proo.type === 1 && proo.description!== ''">
                 {{index+1}}: {{proo.description}}
                </span>
                <span v-else-if="proo.type === 6 && proo.description !== ''">
                 {{index+1}}: {{proo.description}}
                </span>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-block"  style="margin-top: -.75rem">
          <div class="tabs">
            <div id="tab-detail" class="tab active">
                <div class="list-block">
                  <ul v-if="merchandises.categoryId === 20" style="border-top: 0 solid">
                    <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== -1 &&  attribute.value !== '-1'  && attribute.value !== 214 && attribute.value !== '214'  && attribute.valueText !== undefined &&  attribute.groupId === 1">
                      <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :merchandises="merchandises" :attribute="attribute"  :attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" />
                    </li>
                    <hr style="margin-left: 0.7rem;margin-right: 0.1rem; border: 0.5px solid #e7e7e7;">
                    <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1'  && attribute.value !== 214 && attribute.value !== '214'  && attribute.valueText !== undefined && attribute.value !== null &&  attribute.groupId === 2">
                      <editor :is="getEditor(attribute)" v-on:controlForm="controlForm"  :merchandises="merchandises" :attribute="attribute"  :attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" />
                    </li>
                    <li class="item-content">
                      <div class="item-inner" >
                        <div class="item-title" style="color: gray;font-size: .7rem">产品规格</div>
                        <div class="item-after" style="background-color: #E1E1E4;">
                        </div>
                      </div>
                    </li>
                    <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1'  && attribute.value !== 214  && attribute.valueText !== undefined && attribute.value !== '214' &&  attribute.groupId === 3">
                      <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :merchandises="merchandises" :attribute="attribute"  :attrGroups = "attrGroups" :index="index" :param:="$route.params.merchandises" :attributesList="merchandises._attributesList" />
                    </li>
                    <li class="item-content">
                      <div class="item-inner ">
                        <div class="item-title">周期</div>
                        <div class="item-after" v-if="merchandises.workdays">{{merchandises.workdays}}个工作日</div>
                        <div class="item-after" v-else>{{merchandises.cycle}}个工作日</div>
                      </div>
                    </li>
                    <li class="item-content">
                      <div class="item-inner ">
                        <div class="item-title">价格</div>
                        <div class="item-after" v-if="merchandises.priceMax !== undefined">¥{{merchandises.priceMax}}</div>
                        <div class="item-after" v-else >¥{{merchandises.price}}</div>
                      </div>
                    </li>

                    <li class="item-content" v-if="merchandises.priceMin !== undefined ">
                      <div class="item-inner ">
                        <div class="item-title">科研终端用户优惠价</div>
                        <div class="item-after" >¥{{merchandises.priceMin}}</div>
                      </div>
                    </li>
                    <!--定制商品显示秒杀折扣-->
                    <li class="item-content" v-if="showSecPromotionInfo()">
                      <div class="item-inner">
                        <div class="item-title" style="color:#ff0000;">{{numRequiredForSecPromotion}}件秒杀折扣</div>
                        <div class="item-after" style="color:#ff0000;">{{secPromotionRatio}}折</div>
                      </div>
                    </li>
                  </ul>
                  <ul v-else  style="border-top: 0 solid">
                    <li v-for="(attribute,index) in merchandises._attributesList" class="item-content" v-if="attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1'  && attribute.value !== '' && attribute.value !== '214' && attribute.valueText !== undefined && attribute.columnName !=='GeneInfo'">
                      <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :attribute="attribute"  :merchandises='merchandises':attrGroups = "attrGroups" :index="index"  :attributesList="merchandises._attributesList" />
                    </li>
                    <li class="item-content">
                      <div class="item-inner ">
                        <div class="item-title">周期</div>
                        <div class="item-after" v-if="merchandises.workdays">{{merchandises.workdays}}个工作日</div>
                        <div class="item-after" v-else>{{merchandises.cycle}}个工作日</div>
                      </div>
                    </li>
                    <li class="item-content">
                      <div class="item-inner ">
                        <div class="item-title">价格</div>
                        <div class="item-after">¥{{merchandises.price}}</div>
                      </div>
                    </li>
                    <!--<li class="item-content"   v-if="merchandises.showpromotion && merchandises.showpromotion.length > 0" >-->
                      <!--<div class="item-inner ">-->
                        <!--<div class="item-title">参与促销</div>-->
                        <!--<div class="item-after" >-->
                          <!--<span v-for="(proo,index) in merchandises.showpromotion">-->
                              <!--<span v-if="proo.type === 1">-->
                                 <!--{{index+1}}: {{proo.name}}-->
                               <!--</span>-->
                            <!--</span>-->
                        <!--</div>-->

                      <!--</div>-->
                    <!--</li>-->

                  </ul>
<!--                  <div style="font-size: .6rem;margin-left: .5rem;color: gray;margin-bottom: .3rem;margin-top: .3rem ">-->
<!--                    注：如果您成为吉凯会员，将享受更低折扣和更多特权，详细请咨询<a @click="tokefuMessage">在线客服</a>-->
<!--                  </div>-->
                  <div style="font-size: .4rem;margin-left: .5rem;color: gray ">

                    不同产品分装规则说明
                    <div >
                      1.菌液:200μL/tube*1
                    </div>
                    <div>
                      2.质粒:不分装
                    </div>
                    <div>
                      3.慢病毒:50μL/tube
                    </div>
                    <div>
                      4.腺病毒:200μL/tube
                    </div><div>
                    5.逆转录病毒:50μL/tube
                  </div>
                    <div>
                      6.腺相关病毒:50μL/tube
                    </div>
                  </div>
                </div>
            </div>
            <div class="tab " id="tab-introduce">
              <div v-html="introduces"></div>
              <div v-if="merchandises.manualFileName">
                <div v-if="introduces === ''">{{merchandises.description}}</div>
                <div v-if="merchandises.manualFileName.split(';').length === 1">
                  <div @click= "gotomanual(merchandises.manualFileName)" style="color: #0A7CE3">查看商品手册</div>
                </div>
                <div  v-if="merchandises.manualFileName.split(';').length !== 1" v-for="(manualFileName,index) in merchandises.manualFileName.split(';')">
                  <div  style="color: #0A7CE3" @click= "gotomanual(manualFileName)" >查看商品手册{{index+1}}</div>
                  <pdf-preview :url="manualurl + manualFileName" v-if="showmanul"></pdf-preview>
                </div>
              </div>
            </div>
            <div class="tab " id="tab-qualityCommitment">
              <div v-html="qualityCommitment"></div>
            </div>
            <div class="tab" id="tab-comments" style="margin-left: 0rem">
              <div class="list-block media-list" >
                <ul  v-if="Comments.length > 0" >
                  <li v-for="comment in Comments">
                    <div class="item-content" >
                      <div class="item-media"><img src="/emktResources/resocurces/img/user.jpg" width="50"></div>
                      <div class="item-inner">
                        <div class="item-title-row">
                          <div class="item-title">{{comment.customerName}}</div>
                          <div class="item-after">{{comment.createDT.split(' ')[0]}}</div>
                        </div>
                        <div ><span  style="background-color: yellow;margin-left: 0.2rem" v-for="index in comment.commentLevel " class="icon icon-star star"></span></div>
                        <div class="item-text">{{comment.comments}}</div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div v-else>
                  暂无用户评价！
                </div>
              </div>
            </div>
            <div class="tab" id="tab-tlnoImg" style="margin-left: 0rem">
              <div class="list-block media-list" >
                <div v-if="tlnoimgurl !== ''">
                 <img  style="height: 100%;width: 100%" :src="tlnoimgurl"/>
                </div>
                <div v-else>
                   无载体！
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // webmobile/src/views/finder/FinderBox/FinderAttrNumberBox.vue
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import FinderAttrEnumBox from '../../../finder/FinderBox/FinderAttrEnumBox.vue'
  import FinderAttrNumberBox from '../../../finder/FinderBox/FinderAttrNumberBox.vue'
  import FinderAttrTextAreaBox from '../../../finder/FinderBox/FinderAttrTextAreaBox.vue'
  import FinderAttrTextBox from '../../../finder/FinderBox/FinderAttrTextBox.vue'
  import FinderAttrGeneBox from '../../../finder/FinderBox/FinderAttrGeneBox.vue'
  import FinderAttrTVBox from '../../../finder/FinderBox/FinderAttrTVBox.vue'
  import Emkt from '../../../../emkt'
  import wx from 'wx'
  import $ from 'jquery'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: [],
    components: {
      'finder-attr-enum-box': FinderAttrEnumBox,
      'finder-attr-text-box': FinderAttrTextBox,
      'finder-attr-number-box': FinderAttrNumberBox,
      'finder-attr-text-area-box': FinderAttrTextAreaBox,
      'finder-attr-gene-box': FinderAttrGeneBox,
      'finder-attr-tv-box': FinderAttrTVBox
    },
    data () {
      return {
        attrGroups: [],
        curAttrsInGroup: [],
        promotions: [],
        merchandises: [],
        baseurl: '/emktResources/resocurces/img/merchandise/',
        manualurl: '/emktResources/resocurces/manual/',
        merchandiseurl: '/emktResources/resocurces/merchandiseInfo',
        attrurl: '../../../static/filters/',
        attr: '?go=true',
        questionUrl: '../../../static/img/',
        Comments: [],
        QuoteStatus: Emkt.getLocalStorage('QuoteStatus'),
        qualityCommitment: '',
        introduces: '',
        tlnoimgurl: '',
        discountedPrice: 0,
        numRequiredForSecPromotion: Emkt.getLocalStorage('EmktSecPromotion') && Emkt.getLocalStorage('EmktSecPromotion').requiredQuantity,
        from: this.$route.query.from,
        orderStatus: this.$route.query.status,
        routeType: this.$route.query.routeType,
        secPromotionDetail: {},
        isWapp: Emkt.isWapp,
        Tvnopath: '/emktResources/resocurces/img/promotion/SKUIMG/'
      }
    },
    created () {
    },
    mounted () {
      this.fetchData()
    },
    watch: {
//      'merchandises': function (merch) {
//        for (var i in this.merchandises._attributesList) {
//          if (this.merchandises._attributesList[i].sectionId === 4 || this.merchandises._attributesList[i].sectionId === 2) {
//            if (this.merchandises._attributesList[i].value === '' || this.merchandises._attributesList[i].value === -1) {
//              return
//            }
//          }
//        }
//      }
    },
    computed: {
      ...mapState([
        'cartList', 'leaveMessageStatus', 'sessionInfo', 'curMessageSession', 'secPromotionDetailObj'
      ]),
      ...mapGetters([
        'hasLogin', 'curMessageSession', 'secFlag'
        // ...
      ]),
      getTotalGoodsNum () {
        var self = this
        let sum = 0
        Object.keys(this.cartList.cartContent).forEach(function (item) {
          sum += self.cartList.cartContent[item].productQuantity
        })
        return sum
      },
      secPromotionRatio () {
        let ratio = String(100 - this.secPromotionDetail.seckilltRatio * 100)
        ratio = (ratio[1] === '0') ? ratio[0] : ratio
        return ratio
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE', 'FINDER_SEARCH_TEXT'
      ]),
      getSecPromotionDetail () {
        if (!this.merchandises.promotions) return
        for (let promotion of this.merchandises.promotions) {
          if (promotion.type !== 6) continue
          this.secPromotionDetail = this.secPromotionDetailObj[promotion.promotionGuid]
          this.numRequiredForSecPromotion = this.secPromotionDetail && this.secPromotionDetail.requiredQuantity
          break
        }
      },
      tokefuMessage () {
        if (this.hasLogin) {
          var merch = {}
          this.gcapi('retrieveMyLeaveMessages').then((response) => {
            let data = response.body.result.merchantMessages
            for (var i in data) {
              if (data[i].merchantNo === '101') {
                merch.messages = data[i].messages
                merch.merchantName = data[i].merchantName
                merch.merchantNo = data[i].merchantNo
                this.$router.push({name: 'myMessage', query: { Messages: merch }})
              }
            }
          })
        } else {
          alert('请您先去登录！')
        }
//        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
      },
      addCartList () {
        var _this = this
        if (_this.merchandises.selfOperated === 0 && _this.sessionInfo.customerInfo.ssoFlag === 1) {
          $.toast('第三方商品不支持此操作！')
          return
        }
        if (_this.merchandises.categoryId === 20) {
          for (var i in _this.merchandises._attributesList) {
            if (_this.merchandises._attributesList[i].groupId === 2 || _this.merchandises._attributesList[i].groupId === 3) {
              if (_this.merchandises._attributesList[i].value === '' || (_this.merchandises._attributesList[i].valueText === '' && _this.merchandises._attributesList[i].value !== -1)) {
                alert('请将' + _this.merchandises._attributesList[i].label + '信息填写完整！')
                return
              }
            }
          }
//          $.modal({
//            title: '确认订单',
//            afterText: '<div>为了确保您的科研需求，请认真核对您的定制产品参数，我们将严格按照您的要求进行产品生产。如因您产品参数原因导致您后续的实验问题，我司无法针对此中情况为您进行免费售后服务</div>',
//            buttons: [
//              {
//                text: '在线联系',
//                bold: true,
//                onClick: function () {
//                  alert('如有问题，请致电02151320189-8012')
//                }
//              },
//              {
//                text: '确定',
//                bold: true,
//                onClick: function () {
//                }
//              }
//            ]
//          })
          _this.$router.replace({name: 'FinderOrderDeail', params: {merchandises: _this.merchandises}})
        } else {
          let pl = _this.plan
          let pr = _this.merchandises
          if (_this.merchandises.salesLimit !== -1) {
            if (_this.merchandises.totalSales >= _this.merchandises.salesLimit) {
              $.confirm('此商品已经售罄！')
            } else {
              console.log(pl, pr)
              _this.ADD_CART_LIST(pr)
            }
          } else {
            if (pr.specialAnnouncement) {
              $.modal({
                title: '请确认',
                afterText: '<div>我司cDNA克隆产品只作为cDNA模板使用，不承诺过表达。且该产品只提供质粒，不提供菌液。如有疑问，请咨询在线客服。</div>',
                buttons: [
                  {
                    text: '取消',
                    bold: true,
                    onClick: function () {
                      console.log('cancel')
                    }
                  },
                  {
                    text: '确定购买',
                    bold: true,
                    onClick: function () {
                      _this.ADD_CART_LIST(pr)
                    }
                  }
                ]
              })
            } else {
              _this.ADD_CART_LIST(pr)
            }
          }
        }
      },
      checkTlNoImg () {
//        $('#home_keleyi_com').attr('href','http://keleyi.com');
      },
      merchandiseHandler () {
        let md = this.merchandises
        let bMerchandise = {}
        let attribute = []
        // md._customizableAttributes['GeneInfo'] = md._attributesList[md._attributesList.length - 1]
        let attr = md._attributes
        let categoryId
        for (var akey in attr) {
          if (akey === 'GeneInfo') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
            this.geneObject = attr[akey].value
            if (this.geneObject !== null) {
              var taxId = {}
              taxId.columnName = 'GeneInfo.taxId'
              taxId.value = this.geneObject.taxId
              taxId.valueText = this.geneObject.taxId
              var symbol = {}
              symbol.columnName = 'GeneInfo.symbol'
              symbol.value = this.geneObject.symbol
              symbol.valueText = this.geneObject.symbol
              this.merchandises._abstractList.push(taxId)
              this.merchandises._abstractList.push(symbol)
            }
          } else if (akey === 'AAVBloodType]') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
          } else {
            let obj = {}
            obj['key'] = akey
            let val = attr[akey].value
            if (val === '') {
              obj['value'] = -1
            } else if (val) {
              if (val.value !== undefined) {
                obj['value'] = val.value
              } else {
                obj['value'] = val
              }
            } else if (val === 0) {
              obj['value'] = val
            }
            if (obj['key'] === 'TVInfo') {
              obj['value'] = obj['value'].TLNo
            }
//            if (obj['key'] === 'InducingTest' || obj['key'] === 'ExpressionTest' === 0) {
//              obj['value'] = 0
//            }
//            if (obj['key'] === 'ProductGuid') {
//              bMerchandise.productGuid = obj['value']
//            }
            attribute.push(obj)
          }
        }
        let cate = {}
        cate['key'] = 'GeneInfo.category'
        cate['value'] = categoryId
        attribute.push(cate)
        bMerchandise.unitPrice = md.priceMax
        bMerchandise.initPrice = bMerchandise.unitPrice
        bMerchandise.merchandiseGuid = md.merchandiseId
        bMerchandise.amplification = md.amplification
        bMerchandise.attributes = attribute
        bMerchandise.MerchantNo = '101'
//        bMerchandise.productGuid = attribute['ProductGuid'].value
//        bMerchandise.geneObject = geneObject
        return bMerchandise
      },
      gotolast () {
        if (this.from === 'OrderDetailInfo') {
          // this.$router.push({name: 'OrderDetailInfo', query: {status: this.status}})
          this.$router.push({name: 'OrderDetailInfo', query: {status: this.orderStatus, routeType: this.routeType}})
        } else {
          if (this.$route.params.order) {
            this.$router.replace({name: 'orderContent', params: {order: this.$route.params.order}})
          } else {
            this.$router.go(-1)
          }
//        this.$router.push({name: 'finder'})
        }
      },
      controlForm (index, attribute) {
        if (attribute.value === '' || attribute.value === undefined) {
          return
        }
        if (attribute.columnName === 'VirusTiter' && this.merchandises._attributes.LVAmount.value === '') {
          alert('此类合同需要先选择目的病毒总量')
          this.merchandises._attributes.VirusTiter.value = ''
          this.merchandises._attributes.VirusTiter.valueText = ''
          return
        }
        if ((this.merchandises._attributes.ProductGuid.value === 'C20B666F-8896-4AA7-BF1E-5233ED7EECC9' || this.merchandises._attributes.ProductGuid.value === '5640779C-68F8-47DE-92FF-944ED087C951' || this.merchandises._attributes.ProductGuid.value === 'B80D3CEF-618B-49C1-9A13-852A3F0DA146' || this.merchandises._attributes.ProductGuid.value === '3AAA49FE-3576-4589-A382-84AC8286CA63') && attribute.columnName === 'LVAmount') {
          if (attribute.value === '26') {
            this.merchandises._attributes.VirusTiter.value = ''
            this.merchandises._attributes.VirusTiter.valueText = ''
            this.merchandises._attributes.VirusTiter.options = {}
            this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL'
          }
          if (attribute.value === '25') {
            this.merchandises._attributes.VirusTiter.value = ''
            this.merchandises._attributes.VirusTiter.valueText = ''
            this.merchandises._attributes.VirusTiter.options = {}
            this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL'
            this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL'
          }
          if (attribute.value === '27') {
            this.merchandises._attributes.VirusTiter.value = ''
            this.merchandises._attributes.VirusTiter.valueText = ''
            this.merchandises._attributes.VirusTiter.options = {}
            this.merchandises._attributes.VirusTiter.options[4] = '1.00E+13 v.g./mL'
          }
        } else if (this.merchandises._attributes.ProductGuid.value === '195FC008-F234-4D06-8B61-650EA583D506' && attribute.columnName === 'LVAmount') {
          if (attribute.value === '27' || attribute.value === '26' || attribute.value === '25') {
            this.merchandises._attributes.VirusTiter.value = ''
            this.merchandises._attributes.VirusTiter.valueText = ''
            this.merchandises._attributes.VirusTiter.options = {}
            this.merchandises._attributes.VirusTiter.options[3] = '1.00E+12 v.g./mL'
          }
        }
        console.log(this.merchandises)
        for (var i in this.merchandises._attributesList) {
          if (this.merchandises._attributesList[i].groupId === 2 || this.merchandises._attributesList[i].groupId === 3) {
            if (this.merchandises._attributes.ReguTech && this.merchandises._attributes.ReguTech.value === 5 && this.merchandises._attributesList[i].columnName === 'GeneInfo') {
              this.merchandises._attributesList[i].value = -1
            }
            if (this.merchandises._attributesList[i].value === '') {
              return
            }
          }
        }
        var param = {}
        for (var j in this.merchandises._attributesList) {
          if (this.merchandises._attributesList[j].value !== '') {
            var value = ''
            var key = this.merchandises._attributesList[j].columnName
            if (key === 'TVInfo') {
              value = this.merchandises._attributesList[j].value.TLNo
            } else if (key === 'GeneInfo') {
              value = this.merchandises._attributesList[j].value.geneGUID
            } else {
              value = this.merchandises._attributesList[j].value
            }
            param[this.merchandises._attributesList[j].columnName] = value
          }
        }
        var _this = this
        if (this.merchandises.amplification === 1) {
          var bMerchandise = this.merchandiseHandler()
          _this.gcapi('productDetect', bMerchandise).then(res => {
            let body = res.body
            if (body.code === 0) {
              _this.merchandises.productName = body.result.productName
              _this.merchandises.workdays = body.result.workdays
              _this.merchandises.expressPrice = body.result.expressPrice
              _this.merchandises.amplification = body.result.amplification
              if (_this.merchandises.amplification === 1) {
                _this.merchandises.priceMin = body.result.priceMax
              } else {
                _this.merchandises.priceMin = body.result.priceMin
              }
              _this.merchandises.priceMax = body.result.priceMax
            } else {
              alert(body.result)
            }
          })
        } else {
          param['muGuid'] = _this.merchandises.merchandiseId
          console.log('param', param)
          this.gcapi('calculatePrice', param).then((response) => {
            console.log(response)
            this.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount)
            this.merchandises.cycle = response.body.result.workDays
//            this.merchandises.workDays = response.body.result.workDays
            this.merchandises.priceMin = response.body.result.priceMin
          })
        }
      },
      getEditor (attribute) {
//        if (attribute.customizable === 1) {
//          if (attribute.columnName === 'PreContract') {
//            return 'attr-contract-box'
//          } else if (attribute.columnName === 'CloneNrSelect') {
//            return 'attr-target-box'
//          } else if (attribute.columnName === 'TemsPreContract') {
//            return 'attr-temcontract-box'
//          } else {
//            if (attribute.sdType === Emkt.SDTGene) {
//              return 'attr-gene-box'
//            } else if (attribute.sdType === Emkt.SDTToolVector) {
//              return 'attr-tv-box'
//            } else if (attribute.sdType === Emkt.SDTEnumeration) {
//              return 'finder-attr-enum-box'
//            } else if (attribute.sdType === Emkt.SDTInteger) {
//              return 'finder-attr-number-box'
//            } else if (attribute.sdType === Emkt.SDTDecimal) {
//              return 'finder-attr-number-box'
//            } else {
//              return 'finder-attr-text-area-box'
//            }
//          }
//        }
        if (attribute.sdType !== undefined) {
          if (attribute.sdType === Emkt.SDTGene) {
            return 'finder-attr-gene-box'
          } else if (attribute.sdType === Emkt.SDTEnumeration) {
            return 'finder-attr-enum-box'
          } else if (attribute.sdType === Emkt.SDTInteger) {
            return 'finder-attr-number-box'
          } else if (attribute.sdType === Emkt.SDTToolVector) {
            return 'finder-attr-tv-box'
          } else if (attribute.sdType === Emkt.SDTDecimal) {
            return 'finder-attr-number-box'
          } else {
            return 'finder-attr-text-box'
          }
        }
      },
      fetchData () {
        var _this = this
        if (_this.$route.params.merchandises) {
          _this.merchandises = _this.$route.params.merchandises
          if (_this.merchandises.amplification === 1) {
            let bMerchandise = this.merchandiseHandler()
            _this.gcapi('productDetect', bMerchandise).then(res => {
              let body = res.body
              if (body.code === 0) {
                _this.merchandises.productName = body.result.productName
                _this.merchandises.workdays = body.result.workdays
                _this.merchandises.expressPrice = body.result.expressPrice
                _this.merchandises.priceMin = body.result.priceMax
                _this.merchandises.priceMax = body.result.priceMax
              } else {
                alert(body.result)
              }
            })
          }
          if (_this.merchandises.H5FileName) {
            _this.$http.get(this.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, {emulateHTTP: true}).then((response) => {
              _this.introduces = response.bodyText
            })
          }
          if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
            _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg'
          }
          if (_this.merchandises.categoryId === 20) {
            _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, {emulateHTTP: true}).then((response) => {
              _this.qualityCommitment = response.bodyText
            })
          } else {
            if (_this.merchandises.QualityPromisesH5FileName) {
              var dictionariesMap = Emkt.getLocalStorage('EmktMetaData').dictionariesMap
              let name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue
              _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + name, {emulateHTTP: true}).then((response) => {
                _this.qualityCommitment = response.bodyText
              })
            }
          }
          if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
            _this.merchandises._attributes.GeneInfo.displayable = 0
            _this.merchandises._attributes.GeneInfo.value = -1
          }
        } else {
          var method = ''
          if (_this.$route.query.categoryId === 20 || _this.$route.query.categoryId === '20') {
            if (_this.$route.query.cid === 20 || _this.$route.query.cid === '20') {
              method = 'getMerchandiseDetails'
            } else {
              method = 'findMerchandiseDetails'
            }
          } else {
            method = 'getMerchandiseDetails'
          }
          this.gcapi(method, _this.$route.query.id).then((response) => {
            _this.merchandises = response.body.result
            if (_this.$route.query.categoryId === 20) {
              if (!(_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5)) {
                _this.merchandises.priceMin = 0
                _this.merchandises.priceMax = 0
              }
            }
            _this.merchandises._titleList.sort(function (a, b) {
              return a.sortOrder - b.sortOrder
            })
            if (_this.merchandises.geneWord !== '') {
              this.FINDER_SEARCH_TEXT(_this.merchandises.geneWord)
            }
//            _this.merchandises._attributesList.forEach(function (item) {
//              if (item.groupId === 3 && item.displayable !== 0 && item.value !== 214 && item.value !== '214' && item.value !== -1 && item.value !== '-1') {
//                item.value = ''
//                item.valueText = ''
//              }
//            })
            if (_this.merchandises._attributes.ReguTech && _this.merchandises._attributes.ReguTech.value === 5) {
              _this.merchandises._attributes.GeneInfo.displayable = 0
              _this.merchandises._attributes.GeneInfo.value = -1
              var param = {}
              for (var j in _this.merchandises._attributesList) {
//                if (_this.merchandises.categoryId === 20 && _this.merchandises._attributesList[j].groupId === 3) {
//                  _this.merchandises._attributesList[j].value !== ''
//                }
                if (_this.merchandises._attributesList[j].value !== '') {
                  var value = ''
                  var key = _this.merchandises._attributesList[j].columnName
                  if (key === 'TVInfo') {
                    value = _this.merchandises._attributesList[j].value.TLNo
                  } else if (key === 'GeneInfo') {
                    value = _this.merchandises._attributesList[j].value.geneGUID
                  } else {
                    value = _this.merchandises._attributesList[j].value
                  }
                  param[_this.merchandises._attributesList[j].columnName] = value
                }
              }
              param['muGuid'] = _this.merchandises.merchandiseId
              console.log('param', param)
              _this.gcapi('calculatePrice', param).then((response) => {
                _this.merchandises.priceMax = parseFloat(response.body.result.amount) - parseFloat(response.body.result.expressAmount)
                _this.merchandises.cycle = response.body.result.workDays
                _this.merchandises.priceMin = response.body.result.priceMin
              })
            }
            var showpromotion = []
            for (var i in _this.merchandises.promotions) {
              if (_this.merchandises.promotions[i].type === 1 || _this.merchandises.promotions[i].type === 6) {
                showpromotion.push(_this.merchandises.promotions[i])
//              if (self.cartList[item].promotions[i].type === 3) {
//                var allCoupons = Emkt.getLocalStorage('allCoupons')
//                if (allCoupons.length > 0) {
//                  for (var j in allCoupons) {
//                    if (allCoupons[j].promotionGuid === self.cartList[item].promotions[i].promotionGuid) {
//                      showpromotion.push(self.cartList[item].promotions[i])
//                    }
//                  }
//                }
//              } else {
//                showpromotion.push(self.cartList[item].promotions[i])
//              }
              }
            }
            _this.merchandises.showpromotion = showpromotion
            if (_this.merchandises.H5FileName) {
              _this.$http.get(this.merchandiseurl + '/static/desc/' + _this.merchandises.H5FileName, {emulateHTTP: true}).then((response) => {
                _this.introduces = response.bodyText
              })
            }
            if (_this.merchandises._attributes.TVInfo && _this.merchandises._attributes.TVInfo.value.TLNo) {
              _this.tlnoimgurl = _this.Tvnopath + _this.merchandises._attributes.TVInfo.value.TLNo + '.jpg'
            }
            if (_this.merchandises.categoryId === 20) {
              _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + _this.merchandises.QPH5FileName, {emulateHTTP: true}).then((response) => {
                _this.qualityCommitment = response.bodyText
              })
            } else {
              if (_this.merchandises.QualityPromisesH5FileName) {
                var dictionariesMap = Emkt.getLocalStorage('EmktMetaData').dictionariesMap
                let name = dictionariesMap['61090_' + _this.merchandises.QualityPromisesH5FileName].dictValue
                _this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + name, {emulateHTTP: true}).then((response) => {
                  _this.qualityCommitment = response.bodyText
                })
              }
            }
            console.log('merchandises', _this.merchandises)
            this.getSecPromotionDetail()
          })
        }
        _this.gcapi('getMerchandiseComments', _this.$route.query.id).then((response) => {
          _this.Comments = response.body.result
        })
      },
      addcss (data) {
        var obj1 = document.getElementById('detail')
        var obj2 = document.getElementById('introduce')
        var obj3 = document.getElementById('qualityCommitment')
        var obj4 = document.getElementById('comments')
        var obj5 = document.getElementById('tlnoImg')
        if (data === 1) {
          obj1.style.cssText = ' border-bottom: 1px solid ;color: #0894ec;background-color: transparent'
          obj2.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
          if (this.merchandises.categoryId === 20) {
            obj5.style.cssText = 'border: 0px solid black;'
          }
        } else if (data === 2) {
          obj2.style.cssText = ' border-bottom: 1px solid; color: #0894ec;background-color: transparent'
          obj1.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
          if (this.merchandises.categoryId === 20) {
            obj5.style.cssText = 'border: 0px solid black;'
          }
        } else if (data === 3) {
          obj3.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent'
          obj1.style.cssText = 'border: 0px solid black;'
          obj2.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
          if (this.merchandises.categoryId === 20) {
            obj5.style.cssText = 'border: 0px solid black;'
          }
        } else if (data === 4) {
          obj4.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent'
          obj1.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj2.style.cssText = 'border: 0px solid black;'
          if (this.merchandises.categoryId === 20) {
            obj5.style.cssText = 'border: 0px solid black;'
          }
        } else if (data === 5 && this.merchandises.categoryId === 20) {
          obj5.style.cssText = ' border-bottom: 1px solid;color: #0894ec;background-color: transparent'
          obj1.style.cssText = 'border: 0px solid black;'
          obj3.style.cssText = 'border: 0px solid black;'
          obj2.style.cssText = 'border: 0px solid black;'
          obj4.style.cssText = 'border: 0px solid black;'
        }
      },
      toMessage (merchandiseLabel) {
        var _this = this
        this.SEND_MESSAGE({message: '咨询', merchandise: _this.merchandises})
        var merch = {}
        this.gcapi('retrieveMyLeaveMessages').then((response) => {
          let data = response.body.result.merchantMessages
          this.curMessageSession.leaveMessageStatus = data.leaveMessageStatus
          this.curMessageSession.merchantMessages = data.merchantMessages
          this.curMessageSession.messages = data.messages
          this.curMessageSession.messagesAmount = data.messagesAmount
          this.curMessageSession.unreadMessagesAmount = data.unreadMessagesAmount
          console.log(_this.merchandises)
          for (var i in data) {
            if (data[i].merchantNo === _this.merchandises.MerchantNo) {
              merch.messages = data[i].messages
              merch.merchantName = data[i].merchantName
              merch.merchantNo = data[i].merchantNo
              console.log(merch)
              this.$router.replace({name: 'myMessage', params: { merchandiseurl: this.$route.fullPath, merchandises: _this.merchandises }, query: { Messages: merch }})
            }
          }
        })
//        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
      },
      showSecPromotionInfo () {
        if (this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.ssoFlag === 1) {
          return false
        }
        if (this.merchandises.promotions) {
          return this.merchandises.promotions[0] && this.merchandises.promotions[0].type === 6 && this.secFlag !== 2
        } else {
          return this.merchandises.bpromotions && this.merchandises.bpromotions[0] && this.merchandises.bpromotions[0].type === 6 && this.secFlag !== 2
        }
      },
      gotomanual (manualFileName) {
        let url = this.manualurl + manualFileName
        if (Emkt.isWapp) {
          wx.miniProgram.navigateTo({
            url: `/pages/pdf/pdfPage?comeFrom=merchandise&pdfName=${manualFileName}&pdfType=1`
          })
        } else {
          window.open(url)
        }
      }
    }

  }
</script>
<style scoped>

  .bar-header-secondary~.content{top:3.9rem;}
  .bar-footer~.content{bottom:1.0rem}

  .searchbox {
    font-weight: 350;
    padding-left: 1.5rem;
  }
  .goback {
    color: gray;
  }
.specal {
  border-bottom: 0px solid;
}
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
.options {
  color: grey;
  font-size: .6rem;
  width: 120px;
  margin-left: .3rem;
}

  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }
.gotopay{
  position: absolute;
  right: 0;
  background-color: #00469A;
@include wh(5rem, 100%);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2.5rem;
  width: 5rem;
  height: 3rem;}
.gotopay_button_style{
@include sc(.7rem, #F6383A);
  font-weight: bold;
  color: #fff;

}
.button.active {
  z-index: 100;
  color: #00469A;
  background-color: white;
  border-bottom: 1px solid
}
.tab-link.button {
  border: 0px solid black;
  color: gray;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// FinderMerchandiseDetailForGR.vue?a754fa7a